import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import React, { useState, useEffect, useMemo } from "react";
import { TawreedFormField, TawreedInputPlain } from "../../../../../../common/components/form";
import { priceSchemeDto, PriceSchemeService } from "../../../domain";
import { PrimeIcons } from "primereact/api";
import { tawreedTranslationService } from "../../../../../../common/translations";
import { BonusTable } from "../bonus-table";
import { IBonusType } from "../../../../../constants";
import { GlobalContext } from "../../../../../../context";
import { PriceUtils } from "../../../../../../helpers/price";
import "../price-list-form.scss";
import { AuthUtils } from "../../../../../auth/domain";
import { TawreedActionName } from "../../../../../../common/actions";

export type PriceListDetailProps = {
    name: string;
    storeProductId: number,
    priceListId: number,
    price?: number,
    loading?: boolean;
    priceScheme: priceSchemeDto;
    addToCart: ()=> void;
}

export const PriceListDetail: React.FC<PriceListDetailProps> = (_props) => {

    const [data, setData] = useState<priceSchemeDto>({
        ..._props.priceScheme

    });
    const [sellingPrice, setSellingPrice] = useState<number>(0);
    const [loader, setLoader] = useState<boolean>(false);

    const { auth: { user }, constants: { constants } } = React.useContext(GlobalContext);


    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setData({ ..._props.priceScheme });
    }, [_props.priceScheme]);

    const service: PriceSchemeService = useMemo(() => new PriceSchemeService(), []);

    const priceUtils: PriceUtils = new PriceUtils();
   useEffect(()=>{
        let time = setTimeout(() => {
            setLoader(true);
            priceUtils.getSellingPrice(data.price ?? 0, data.discountType ?? 'fixed', data.discountValue ?? 0, user?.scale!)
                .then((res) => {
                    setLoader(false);
                    if (res > 0) {
                        setSellingPrice(res);
                    }
                    else {
                        setSellingPrice(0);
                    }
        }).catch((res)=>{
            setLoader(false);
        });
        }, 500)

        return () => clearTimeout(time);
    },[data.discountType, data.discountValue, data.price]);

    return (
        <Panel header={_props.name}
            collapsed={true} toggleable={!data.priceSchemeId}
            icons={
                <React.Fragment>
                    {data.priceSchemeId && AuthUtils.current().authorized(TawreedActionName.StoreProductsSubmit) &&
                        <Button
                            label={tawreedTranslationService.translate("lbl_add_to_cart")}
                            icon={PrimeIcons.SHOPPING_CART}
                            className={"p-button-text ml-1"}
                            onClick={() => {
                                _props.addToCart();
                            }
                            }
                        />
                    }

                </React.Fragment>

            }
            className="col-12 priceListForm">

            <div className="grid">


                <TawreedFormField name="price" title="lbl_price_scheme_price" className="field col-3 lg:col-3 md:col-6">
                    <TawreedInputPlain name="storeItemId" render="form" value={data?.price} mode="numeric" />


                </TawreedFormField>

                <TawreedFormField className="field col-3 lg:col-3 md:col-6" name="discountType" title="lbl_price_scheme_discountType">
                    <TawreedInputPlain name="discountType" value={data?.discountType} render="form" />


                </TawreedFormField>
                <TawreedFormField name="discountValue" title="lbl_price_scheme_discountValue" className="field col-3 lg:col-3 md:col-6">
                    <TawreedInputPlain name="discountValue" value={data?.discountValue} render="form" mode="numeric" />


                </TawreedFormField>
                <TawreedFormField name="sellingPrice" title="lbl_sellingPrice" className="field col-3 lg:col-3 md:col-6 mt-1">
                    <span>
                        {loader && <i className="pi pi-spinner pi-spin ml-2"></i>}

                        <TawreedInputPlain value={sellingPrice} name="sellingPrice" render="standalone" className="mt-1" />

                    </span>
                </TawreedFormField>
                <BonusTable
                    className="col-12 md:col-12"
                    data={data?.bonuses?.filter(el => el.bonusType === IBonusType.EXTRA_ITEMS) ?? []}
                    title={"lbl_store_products_bonus_title"}
                    deleteBonusById={() => { }}
                    // disabeld={disabeld || !data.discountType || !data.price}
                    disabeld={true}
                    addBonus={() => { }}
                    loading={false}
                    bonusType={IBonusType.EXTRA_ITEMS}
                ></BonusTable>
                <BonusTable
                    className="col-12 md:col-12"
                    data={data?.bonuses?.filter(el => el.bonusType === IBonusType.DISCOUNT) ?? []}
                    title={"lbl_store_products_discount_bonus_title"}
                    deleteBonusById={() => { }}
                    addBonus={() => { }}
                    disabeld={true}
                    // disabeld={disabeld || !data.discountType || !data.price}
                    loading={false}
                    bonusType={IBonusType.DISCOUNT}
                    singlePrice={data.price && data.price > 0 ? sellingPrice : 0}
                ></BonusTable>

            </div>
        </Panel>


    )
}
